import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { reduxForm } from "redux-form";
import * as R from "ramda";
import { Button } from "cxa-components";
import { StringField } from "cxa-form-field";
import { login } from "actions/loginActions";
import { intlShape } from "react-intl";
import messages from "components/messagesDescription";

const validateRequired = intl => value =>
  value ? null : intl.formatMessage(messages.requiredDescription);

const LoginForm = ({
  handleSubmit,
  submitting,
  error,
  resourceId,
  loginLabel,
  initialValues,
  intl,
  reset,
}) => (
  <form className="cxa-c-form" onSubmit={handleSubmit} autoComplete="off">
    <fieldset>
      {!initialValues.clientName && (
        <StringField
          label={intl.formatMessage(messages.companyIdDescription)}
          name="clientName"
          validate={validateRequired(intl)}
          boxed
          autoCapitalize="off"
          autoCorrect="off"
        />
      )}
      <StringField
        label={
          loginLabel
            ? intl.formatMessage({ id: loginLabel, defaultMessage: loginLabel })
            : intl.formatMessage(messages.loginIdDescription)
        }
        name="username"
        validate={validateRequired(intl)}
        boxed
        autoCapitalize="off"
        autoCorrect="off"
        autoComplete="false"
        onFocus={evt => {
          evt.currentTarget.value = evt.currentTarget.value;
        }}
      />
      <StringField
        label={intl.formatMessage(messages.passwordDescription)}
        name="password"
        type="password"
        autoComplete="new-password"
        validate={validateRequired(intl)}
        boxed
      />
    </fieldset>
    {error && reset() && (
      <div className="form__alert alert alert--error">
        {intl.formatMessage({
          id: resourceId,
          defaultMessage: resourceId,
        })}
      </div>
    )}
    <div className="form__actions">
      <Button submitting={submitting} primary className="u-margin-bottom" style={{ width: "100%" }}>
        {intl.formatMessage(messages.loggedInTextDescription)}
      </Button>
      <Link className="link-silent" to="/forgotPassword">
        {intl.formatMessage(messages.forgotLoginTextDescription)}
      </Link>
    </div>
  </form>
);

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  error: PropTypes.string,
  resourceId: PropTypes.string,
  loginLabel: PropTypes.string,
  initialValues: PropTypes.object,
  intl: intlShape.isRequired,
  reset: PropTypes.func,
};

export default R.compose(
  reduxForm({
    form: "login",
    onSubmit: (model, dispatch, props) =>
      login(
        {
          ...model,
          ...props,
        },
        dispatch,
        props
      ),
    enableReinitialize: true,
    keepDirtyOnReinitialize: false,
  })
)(LoginForm);



// WEBPACK FOOTER //
// ./components/login/LoginForm.js